import { useEffect, useRef } from "react";
import { useAuth } from "@/lib/auth";
import { initializeOneSignal, isOneSignalAvailable, OneSignal } from "@/lib/onesignal";

export default function OneSignalManager({ children }) {
  const { user } = useAuth();
  const lastParticipantId = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const syncOneSignalUser = async () => {
      if (!isOneSignalAvailable()) {
        return;
      }
      try {
        await initializeOneSignal();
        if (cancelled) {
          return;
        }
        if (user?.role === "participant") {
          await OneSignal.login(String(user.id));
          lastParticipantId.current = user.id;
        } else if (lastParticipantId.current) {
          await OneSignal.logout();
          lastParticipantId.current = null;
        }
      } catch (error) {
        console.warn("OneSignal tidak tersedia.", error);
      }
    };

    syncOneSignalUser();
    return () => {
      cancelled = true;
    };
  }, [user?.id, user?.role]);

  return children;
}